import React, { Component } from 'react'
import config from '../../config'

class Oops extends Component {
	render() {
		return (
			<div className="row">
				<div className="col-1 sm-hidden" />
				<div className="score-page col-4 col-sm-4 col-xs-2">
					<h1 className="text-1-type-2">Oops :(</h1>
					<div className="description font-regular text-3-type-3">
						Seems, you are using a mobile browser.
						Switch to a desktop to try out Handl demo.
					</div>
					<div className="buttons">
						<a
							className="btn"
							href={config.outer.index}
						>
							Go back
						</a>
					</div>
				</div>
			</div>
		)
	}
}

export default Oops
